module.exports = __webpack_public_path__ + "static/media/ilu3.04177ffd.png";